import { render, staticRenderFns } from "./TaxDepositEntry.vue?vue&type=template&id=45f24afd&scoped=true&"
import script from "./TaxDepositEntry.vue?vue&type=script&lang=js&"
export * from "./TaxDepositEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f24afd",
  null
  
)

export default component.exports